module.exports = __webpack_public_path__ + "static/media/rover-curiosity.d55704c8.svg";